
import { EntitysSelectors } from "@shared/src/enums/EntitysSelectors";
import { EntitySelectorDto } from "../EntitySelectorDto";

export class ManagementModelEntitySelectorDto extends EntitySelectorDto {

	public static new(activeFilterKeys: Array<String>): ManagementModelEntitySelectorDto {
		let result: ManagementModelEntitySelectorDto = new ManagementModelEntitySelectorDto();
		result.loadData(EntitysSelectors.ManagementModel, "", activeFilterKeys, 0, false);
		return result;
	}

	public getUrlGoToMaintenance(): string {
		return "system/dataandparameters/managementmodel";
	}

	public getUrlBack(): string {
		return "/maintenance/managementmodel";
	}

}